const Config = {
  'Match.list.product': {
    operation: ['VISIBLE'],
    title: '商品列表',
    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        return [
          {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item?.item?.index + 1,
            c: 'product',
            iid: `next=product.${item?.item?.productId}`,
          },
        ];
      },
    },
  },
  'Match.product.touch': {
    operation: ['TOUCH'],
    title: '商品列表',
    c: {
      type: 'constant',
      value: 'product',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: ({ productId, u }) => {
        return `next=productId.${productId}&u=${u}`;
      },
    },
  },
  'Match.bottom.botton': {
    operation: ['TOUCH'],
    title: '底部按钮',
    c: {
      type: 'constant',
      value: 'purchase',
    },
    iid: {
      type: 'variable',
      func: ({ skus }) => {
        return `skus=${skus}`;
      },
    },
  },
};

export default Config;
